import React, { useEffect, useState } from 'react';
import { ACTIONS as notificationActions } from 'actions/notification';
import { actions as modalActions } from 'actions/modal';

import { useTranscribeGet, useTranscribePost } from 'actions/transcribe';
import { useConfigPost } from 'actions/configs';
import { trackEvent } from 'modules/analytics';
import { getCookie } from 'utils';

import { Col, Button } from '@cuemath/comps';
import { useDispatch } from 'react-redux';

const getIdFromS3Url = url => {
  const splitted = url.split('/');
  const lastItem = splitted[splitted.length - 1];
  if (lastItem === 'archive.mp4') {
    return splitted[splitted.length - 2];
  } else {
    return lastItem.split('.mp4')[0];
  }
};

const Transcribe = ({ logUrl }) => {
  const teacherClassroomId = window.location.href.split('classroom/')[1];
  const [isBusy, setIsBusy] = useState(true);
  const [signedUrl, setSignedUrl] = useState('');
  const [label, setLabel] = useState('Transcribe');
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  const videoUrl = logUrl.includes('videoUrl=') ? logUrl.split('videoUrl=')[1] : logUrl;
  const s3Url = 's3:/' + videoUrl.split('com')[1];
  const id = getIdFromS3Url(s3Url);

  const eventData = {
    classroom_id: teacherClassroomId,
    archieve_id: id,
    actor_id: getCookie('user_id') || getCookie('emp_id'),
  };

  const {
    get: getTranscribe,
    data,
    isProcessed: transcribeGetProcessed,
  } = useTranscribeGet();

  const { post: startTranscribe } = useTranscribePost({
    onComplete: errorMessage => {
      if (errorMessage) {
        setIsBusy(false);
        trackEvent('TRANSCRIBE_FAILED', eventData);
        dispatch({
          type: notificationActions.SHOW_NOTIFICATION,
          payload: {
            text: 'Something went wrong.',
            duration: 10,
            showCloseIcon: true,
          },
        });
      } else {
        setIsBusy(true);
      }
    },
  });

  const { post: createAWSSignedUrl } = useConfigPost({
    onComplete: (errorMessage, data) => {
      if (errorMessage) {
        dispatch({
          type: notificationActions.SHOW_NOTIFICATION,
          payload: {
            text: 'Something went wrong.',
            duration: 10,
            showCloseIcon: true,
          },
        });
      } else {
        setIsBusy(false);
        setLabel('View Transcript');
        setSignedUrl(data);
      }
    },
  });

  useEffect(() => {
    getTranscribe(teacherClassroomId, { file_name: id });
  }, [getTranscribe, id, teacherClassroomId]);

  useEffect(() => {
    if (transcribeGetProcessed) {
      if (data === 'COMPLETED') {
        setIsVisible(true);
        createAWSSignedUrl({ bucket: 'class-transcribes', key: id });
      } else if (data === 'NOT_FOUND') {
        setIsBusy(false);
        setLabel('Transcribe');
        setIsVisible(true);
      } else if (data === 'FAILED') {
        setIsBusy(true);
        setLabel('Failed');
      } else if (data === 'IN PROGRESS' || data === 'QUEUED') {
        setIsBusy(true);
      }
    }
  }, [createAWSSignedUrl, data, dispatch, id, transcribeGetProcessed]);

  const runTranscribe = () => {
    trackEvent('TRANSCRIBE_STARTED', eventData);
    startTranscribe({ file_name: id, file_url: s3Url }, { teacherClassroomId });
    setIsBusy(true);
  };

  const viewTranscribe = () => {
    trackEvent('TRANSCRIBE_VIEWED', eventData);
    dispatch({
      type: modalActions.MODAL_OPEN,
      payload: {
        name: 'transcriptModal',
        options: {
          size: 'custom',
          width: `${Math.ceil((window.innerWidth * 70) / 100)}px`,
          height: `${Math.ceil((window.innerHeight * 70) / 100)}px`,
        },
        props: {
          signedUrl,
          teacherClassroomId,
        },
      },
    });
  };
  if (!isVisible) {
    return null;
  }
  return (
    <Col>
      <Button
        label={label}
        onClick={label === 'Transcribe' ? runTranscribe : viewTranscribe}
        busy={isBusy}
        disabled={isBusy}
      />
    </Col>
  );
};

export default Transcribe;
